export default __webpack_public_path__ + "static/media/summary.798f03fd.png";